import { render, staticRenderFns } from "./news_details.vue?vue&type=template&id=3002508b&"
import script from "./news_details.vue?vue&type=script&lang=js&"
export * from "./news_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports